import { useMutation } from "react-query";
import AssignedLoanCard from "../../components/card/DrawerCards/AssignedLoanCard";
import { GetCheques } from "../../services/cheque.service";
import { ICheqeuResponse, IGetCheqeuRequest } from "../../models/cheque.model";
import { useEffect, useState } from "react";
import { useAuth } from "../../config/AuthProvider/authProvider";
import ChequeCard from "../../components/chequeCard/chequeCard";
import { IContainerApp } from "../navigationButtonComponents/loansTab/containerApp/IContainerApp";
import { useAppBar } from "../../components/appBar/appBarContext";
import { useDispatch } from "react-redux";
import { changeRouteType } from "../../redux/handleBackBtn/handleBackBtnSlice";
import { ICheques } from "./ICheque";


export default function Cheques({ cheques, handleClick }: ICheques) {




    // const handleChequeClick = (chequeId: number) => {
    //     handleClick(chequeId);
    // }



    return (
        <div className="pb-5">

            {cheques?.map((item: ICheqeuResponse, index: number) => {
                return (
                    <ChequeCard chequeInfo={item} onClick={handleClick} index={index}></ChequeCard>
                )
            })}
        </div>
    )
}